<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="d-flex align-center">
          <h2 class="headline">
            <span class="font-weight-bold d-flex align-center">
              <v-icon class="mr-3 black--text" @click="goBack()">mdi-arrow-left</v-icon>
              {{ $t('summary') }}
            </span>
          </h2>
          <v-spacer />
          <h3 class="link-text primary--text cursor-pointer" @click="addMore()">
            {{ $t('add_product') }}
          </h3>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-if="this.$store.state.selected_type == 'DELIVERY'" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <v-card class="__card-online-order">
          <v-card-text>
            <h5 class="subtitle-1 font-weight-bold text--primary">
              {{ $t('destination') }}
            </h5>
            <div class="my-3">
              <div class="d-flex align-center">
                <v-icon color="orange darken-2" class="mr-2">
                  mdi-map-marker
                </v-icon>
                <span class="text--primary text-two-line">
                  {{ dataInCart.shipping_address }}
                </span>
                <router-link :to="{ name: 'search_map' }" class="primary--text text-non-direction ml-1">
                  {{ $t('change') }}
                </router-link>
              </div>
            </div>
            <v-text-field v-model="dataInCart.notes" solo hide-details label="tambahkan catatan untuk driver" prepend-inner-icon="mdi-file-document-outline" />
            <div class="my-3">
              <div class="d-flex align-center">
                <div v-if="dataInCart.shipping_delivery_type === 1" class="font-weight-bold __cart-shipping-method">
                  <template v-if="!$isEmpty(selected_outlet.delivery) && totalPriceItem < Number(selected_outlet.delivery.minimum_order)">
                    <div>
                      <div class="shipping-method-tittle">
                        {{ $t('delivery_2') }} {{ dataInCart.shipping_time }}
                      </div>
                      <div class="shipping-method-description">
                        <b v-mask-money="dataInCart.shipping_cost" />
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div v-if="dataInCart.shipping_radius > $store.state.selected_outlet.delivery.radius_free_delivery">
                      <div class="shipping-method-tittle">
                        {{ $t('free_shipping') }}, {{ dataInCart.shipping_time }}
                      </div>
                      <div class="shipping-method-description">
                        <span v-mask-money="(!$isEmpty(selected_outlet.delivery) ? selected_outlet.delivery.cost_outside_radius * dataInCart.shipping_radius : 0)" class="mr-2" />
                        <b v-mask-money="dataInCart.shipping_cost" />
                      </div>
                    </div>
                    <div v-else>
                      <div class="shipping-method-tittle">
                        {{ $t('free_shipping') }}, {{ dataInCart.shipping_time }}
                      </div>
                    </div>
                  </template>
                  <!-- <template v-if="selected_outlet.delivery.radius_free_delivery !== 0">
                    <div class="shipping-method-tittle">
                      Bebas Ongkir, {{ dataInCart.shipping_time }}
                    </div>
                    <template v-if="dataInCart.shipping_radius > selected_outlet.delivery.radius_free_delivery">
                      <div class="shipping-method-description">
                        <span v-mask-money="(selected_outlet.delivery.cost_outside_radius * dataInCart.shipping_radius)" class="mr-2" />
                        <b v-mask-money="(dataInCart.shipping_radius - selected_outlet.delivery.radius_free_delivery) * selected_outlet.delivery.cost_outside_radius" />
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="shipping-method-tittle">
                      Ongkir, {{ dataInCart.shipping_time }}
                    </div>
                    <div class="shipping-method-description">
                      <b v-mask-money="(dataInCart.shipping_radius - selected_outlet.delivery.radius_free_delivery) * selected_outlet.delivery.cost_outside_radius" />
                    </div>
                  </template> -->
                </div>
                <div v-else-if="dataInCart.shipping_delivery_type === 2" class="font-weight-bold __cart-shipping-method">
                  <div class="shipping-method-tittle">
                    {{ dataInCart.shipping_courier_name }}
                  </div>
                  <div class="shipping-method-description">
                    <b v-mask-money="dataInCart.shipping_cost" class="black--text" />
                  </div>
                </div>
                <v-spacer />
                <v-btn color="primary" outlined small :to="{ name: 'delivery_method' }" class="text-none">
                  {{ $t('change_method') }}
                </v-btn>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="this.$store.state.selected_type == 'DINE-IN'" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div v-if="typeof dataInCart.table_detail !== 'undefined' && !$isEmpty(dataInCart.table_detail)" class="row-table-cart">
          <div class="d-flex align-center">
            <div class="d-flex mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.301" height="15.251" viewBox="0 0 18.301 15.251" class="svg-table-cart">
                <g id="surface1" transform="translate(-0.992 -3.473)">
                  <path id="Path_1" data-name="Path 1" d="M3.577,3.473a1.444,1.444,0,0,0,0,2.885,1.444,1.444,0,0,0,0-2.885Zm13.131,0A1.444,1.444,0,1,0,18.1,4.914,1.42,1.42,0,0,0,16.708,3.473ZM3.577,6.77A1.418,1.418,0,0,0,2.186,8.211l.006,4.242a1.419,1.419,0,0,0,1.385,1.321H4.758l.3-2.058H4.971l0-3.528A1.452,1.452,0,0,0,3.577,6.77Zm13.131,0a1.457,1.457,0,0,0-1.391,1.418l0,3.528h-.085l.3,2.058h1.181a1.417,1.417,0,0,0,1.385-1.321L18.1,8.211A1.418,1.418,0,0,0,16.708,6.77ZM1.384,7.176a.406.406,0,0,0-.392.419v5.891a1.63,1.63,0,0,0,.774,1.3l-.373,3.479a.4.4,0,1,0,.79.091l.36-3.343H5.385l-.41,2.824a.439.439,0,0,0,.05.269c.081.146.448.617,1.745.617a2.555,2.555,0,0,0,1.385-.315V15.424a.4.4,0,1,1,.8,0v3.012a2.21,2.21,0,0,0,1.194.286,2.219,2.219,0,0,0,1.194-.286V16.248a.4.4,0,1,1,.8,0V18.39a2.836,2.836,0,0,0,1.416.331,2.224,2.224,0,0,0,1.654-.539.426.426,0,0,0,.107-.347L14.9,15.011h2.845l.357,3.343a.407.407,0,0,0,.442.367.414.414,0,0,0,.351-.458l-.373-3.479a1.627,1.627,0,0,0,.771-1.3V7.595a.42.42,0,0,0-.116-.3.39.39,0,0,0-.288-.12.406.406,0,0,0-.392.419V13.44a.774.774,0,0,1-.768.746H14.781l-.664-4.593a.4.4,0,0,0-.395-.35H6.563a.405.405,0,0,0-.395.35L5.5,14.187H2.556a.774.774,0,0,1-.768-.746V7.595a.433.433,0,0,0-.116-.3A.4.4,0,0,0,1.384,7.176Z" transform="translate(0)" />
                </g>
              </svg>
            </div>
            <div class="font-14 font-weight-bold primary--text">
              {{ $t('table') }} {{ dataInCart.table_detail.name }}
            </div>
          </div>
        </div>
      </v-col>
      <v-col v-if="this.$store.state.selected_type == 'RESERVATION'" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="row-table-cart">
          <div class="d-flex align-center">
            <div class="d-flex mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svg-calender-cart">
                <g id="Group_25940" data-name="Group 25940" transform="translate(-32 -501)">
                  <rect id="Rectangle_43012" data-name="Rectangle 4304" width="24" height="24" transform="translate(32 501)" fill="#fff" opacity="0" />
                  <path id="calendar_today_FILL0_wght400_GRAD0_opsz48" d="M7.282,21.088A1.314,1.314,0,0,1,6,19.806V6.563A1.314,1.314,0,0,1,7.282,5.282H8.67V4h1.388V5.282h7.262V4h1.388V5.282H20.1a1.314,1.314,0,0,1,1.282,1.282V19.806A1.314,1.314,0,0,1,20.1,21.088Zm0-1.282H20.1V10.622H7.282Zm0-10.466H20.1V6.563H7.282Zm0,0v0Z" transform="translate(30.31 500.456)" />
                </g>
              </svg>
            </div>
            <div class="font-14 font-weight-bold primary--text">
              {{ formatReserveDate }}, {{ dataInCart.reserve_time }}
            </div>
          </div>
          <div class="d-flex align-center">
            <div class="d-flex mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="18.301" height="15.251" viewBox="0 0 18.301 15.251" class="ml-1 svg-table-cart">
                <g id="surface1" transform="translate(-0.992 -3.473)">
                  <path id="Path_1" data-name="Path 1" d="M3.577,3.473a1.444,1.444,0,0,0,0,2.885,1.444,1.444,0,0,0,0-2.885Zm13.131,0A1.444,1.444,0,1,0,18.1,4.914,1.42,1.42,0,0,0,16.708,3.473ZM3.577,6.77A1.418,1.418,0,0,0,2.186,8.211l.006,4.242a1.419,1.419,0,0,0,1.385,1.321H4.758l.3-2.058H4.971l0-3.528A1.452,1.452,0,0,0,3.577,6.77Zm13.131,0a1.457,1.457,0,0,0-1.391,1.418l0,3.528h-.085l.3,2.058h1.181a1.417,1.417,0,0,0,1.385-1.321L18.1,8.211A1.418,1.418,0,0,0,16.708,6.77ZM1.384,7.176a.406.406,0,0,0-.392.419v5.891a1.63,1.63,0,0,0,.774,1.3l-.373,3.479a.4.4,0,1,0,.79.091l.36-3.343H5.385l-.41,2.824a.439.439,0,0,0,.05.269c.081.146.448.617,1.745.617a2.555,2.555,0,0,0,1.385-.315V15.424a.4.4,0,1,1,.8,0v3.012a2.21,2.21,0,0,0,1.194.286,2.219,2.219,0,0,0,1.194-.286V16.248a.4.4,0,1,1,.8,0V18.39a2.836,2.836,0,0,0,1.416.331,2.224,2.224,0,0,0,1.654-.539.426.426,0,0,0,.107-.347L14.9,15.011h2.845l.357,3.343a.407.407,0,0,0,.442.367.414.414,0,0,0,.351-.458l-.373-3.479a1.627,1.627,0,0,0,.771-1.3V7.595a.42.42,0,0,0-.116-.3.39.39,0,0,0-.288-.12.406.406,0,0,0-.392.419V13.44a.774.774,0,0,1-.768.746H14.781l-.664-4.593a.4.4,0,0,0-.395-.35H6.563a.405.405,0,0,0-.395.35L5.5,14.187H2.556a.774.774,0,0,1-.768-.746V7.595a.433.433,0,0,0-.116-.3A.4.4,0,0,0,1.384,7.176Z" transform="translate(0)" />
                </g>
              </svg>
            </div>
            <div class="font-14 font-weight-bold primary--text">
              {{ dataInCart.total_guest }} {{ $t('table') }}
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="__item-in-checkout">
          <template v-for="(item, index) in dataInCart.item">
            <table :key="index + '-item-checkout'" class="__table-checkout">
              <thead>
                <tr>
                  <th width="50" />
                  <th />
                  <th width="100" />
                </tr>
              </thead>
              <tbody>
                <tr class="subtitle-1 font-weight-bold">
                  <td>{{ item.qty }}x</td>
                  <td>
                    <div class="d-block">
                      {{ item.name }} <span v-if="item.product_variant_name">({{ item.product_variant_name }})</span>
                    </div>
                    <span v-if="item.product_combo_items && !$store.state.selected_outlet.hide_combo_item" class="__variant">
                      <template v-for="(combo_items, idx) in item.product_combo_items">
                        {{ combo_items.name }}
                        <span v-if="combo_items.variant_name" :key="idx + '-variant-name'">({{ combo_items.variant_name }})</span>
                        <span v-if="(item.product_combo_items.length - idx) != 1" :key="idx + '-plus'" v-html="'+'" />
                      </template>
                    </span>
                    <template v-if="item.addons.length !== 0">
                      <span v-for="(addons_item, key) in item.addons" :key="key + '-addon'" class="__variant">
                        {{ addons_item.product_addon_name }}
                        <span v-if="(item.addons.length - key) !== 1" :key="key + '-plus'" v-html="'+'" />
                      </span>
                    </template>
                  </td>
                  <td class="text-right">
                    <span v-mask-money-only="item_price[index]" />
                  </td>
                </tr>
                <tr class="body-2">
                  <td />
                  <td>
                    <template v-if="item.note">
                      <div class="d-flex align-center">
                        <span class="grey--text lighten-1 __note-checkout">
                          <v-icon left color="grey lighten-1">
                            mdi-file-document-outline
                          </v-icon>
                          <span>
                            {{ item.note }}
                          </span>
                        </span>
                        <span>
                          <v-btn color="primary" small text class="text-none ml-2" @click="showPopupNote(index, 'update')">
                            Edit
                          </v-btn>
                        </span>
                      </div>
                    </template>
                    <v-btn v-else small color="primary" dark class="text-none" @click="showPopupNote(index, 'create')">
                      <v-icon dark left>
                        mdi-file-document-outline
                      </v-icon>
                      {{ $t('add_note2') }}
                    </v-btn>
                  </td>
                </tr>
                <tr>
                  <td colspan="2" />
                  <td>
                    <div class="d-flex align-center justify-center">
                      <v-btn color="primary" fab outlined x-small @click="minus(index)">
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                      <p class="px-2 __qty-checkout">
                        {{ item.qty }}
                      </p>
                      <v-btn color="primary" fab outlined x-small @click="plus(index)">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </v-col>
    </v-row>
    <v-row :style="{ marginBottom: heightMenu + 'px' }">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <div class="__price-wrapper d-flex flex-column mt-3">
          <div class="__data-price">
            <h4>
              {{ $t('subtotal') }}
            </h4>
            <v-spacer />
            <h4>
              {{ totalPriceItem }}
            </h4>
          </div>
          <template v-if="dataInCart.discount_detail">
            <div v-if="dataInCart.discount_detail" class="__data-price">
              <h4>
                {{ $t('discount') }} ({{ dataInCart.discount_detail.discount_code }})
              </h4>
              <v-spacer />
              <h4 v-if="!dataInCart.discount_detail.discount_is_percentage" class="color-price">
                -{{ Math.round(dataInCart.discount_detail.discount_to_amount) }}
              </h4>
              <h4 v-else class="color-price">
                -{{ dataInCart.discount_detail.discount_rate * 100 }}% (-{{ Math.round(dataInCart.discount_detail.discount_to_amount) }})
              </h4>
            </div>
          </template>

          <template v-if="dataInCart.shipping_delivery_type === 1">
            <template v-if="!$isEmpty(selected_outlet.delivery) && totalPriceItem < Number(selected_outlet.delivery.minimum_order)">
              <div class="__data-price">
                <h4>
                  {{ $t('shipping') }}
                </h4>
                <v-spacer />
                <h4>
                  {{ dataInCart.shipping_cost }}
                </h4>
              </div>
            </template>
            <template v-else>
              <div v-if="dataInCart.shipping_radius > $store.state.selected_outlet.delivery.radius_free_delivery" class="__data-price">
                <h4>
                  {{ $t('shipping') }}
                </h4>
                <v-spacer />
                <h4>
                  {{ dataInCart.shipping_cost }}
                </h4>
              </div>
              <div v-else class="__data-price">
                <h4>
                  {{ $t('shipping') }}
                </h4>
                <v-spacer />
                <h4>
                  Free
                </h4>
              </div>
            </template>
          </template>

          <template v-if="dataInCart.shipping_delivery_type === 2">
            <div class="__data-price">
              <h4>
                {{ $t('shipping') }}
              </h4>
              <v-spacer />
              <h4>
                {{ dataInCart.shipping_cost }}
              </h4>
            </div>
          </template>

          <!-- <div v-if="" class="font-weight-bold __cart-shipping-method">
            <template v-if="">
              <div>
                <div class="shipping-method-tittle">
                  Pengantaran {{ dataInCart.shipping_time }}
                </div>
                <div class="shipping-method-description">
                  <b v-mask-money="" />
                </div>
              </div>
            </template>
            <template v-else>
              <div >
                <div class="shipping-method-tittle">
                  Bebas Ongkir, {{ dataInCart.shipping_time }}
                </div>
                <div class="shipping-method-description">
                  <span v-mask-money="(selected_outlet.delivery.cost_outside_radius * dataInCart.shipping_radius)" class="mr-2" />
                  <b v-mask-money="dataInCart.shipping_cost" />
                </div>
              </div>
              <div v-else>
                <div class="shipping-method-tittle">
                  Bebas Ongkir, {{ dataInCart.shipping_time }}
                </div>
              </div>
            </template>
          </div> -->

          <!-- <div v-if="$store.state.selected_type === 'OL-TAKE-AWAY' || $store.state.selected_type === 'DELIVERY'" class="__data-price">
            <h4>
              Payment Charge
            </h4>
            <v-spacer />
            <h4 v-mask-money="extra_charge" />
          </div> -->

          <template v-if="$store.state.selected_type === 'OL-TAKE-AWAY' || $store.state.selected_type === 'DELIVERY'">
            <div v-if="totalConvenienceFee > 0" class="__data-price">
              <h4>
                {{ $t('convenience_fee') }}
              </h4>
              <v-spacer />
              <h4>
                {{ totalConvenienceFee }}
              </h4>
            </div>
            <template v-if="selected_outlet.pos_take_away_with_service_charge">
              <template v-if="(extra_charge || Number(extra_charge) > 0) && !selected_outlet.price_service_charge_included && totalExtraCharge > 0">
                <div class="__data-price">
                  <h4>
                    {{ $t('service_charge') }}
                    <!-- request tim support di dukung oleh pak ali -->
                    <!-- ({{ Number((Number(extra_charge) * 100).toFixed(2)) }}%) -->
                  </h4>
                  <v-spacer />
                  <h4>
                    {{ totalExtraCharge }}
                  </h4>
                </div>
              </template>
            </template>
          </template>
          <template v-else>
            <div v-if="$store.state.selected_type === 'RESERVATION' && totalConvenienceFee > 0" class="__data-price">
              <h4>
                {{ $t('convenience_fee') }}
              </h4>
              <v-spacer />
              <h4>
                {{ totalConvenienceFee }}
              </h4>
            </div>
            <template v-if="(extra_charge || Number(extra_charge) > 0) && !selected_outlet.price_service_charge_included">
              <div class="__data-price">
                <h4>
                  {{ $t('service_charge') }}
                  <!-- request tim support di dukung oleh pak ali -->
                  <!-- ({{ Number((Number(extra_charge) * 100).toFixed(2)) }}%) -->
                </h4>
                <v-spacer />
                <h4>
                  {{ totalExtraCharge }}
                </h4>
              </div>
            </template>
          </template>

          <template v-if="$store.state.selected_type === 'OL-TAKE-AWAY' || $store.state.selected_type === 'DELIVERY'">
            <template v-if="selected_outlet.pos_take_away_no_tax !== 1">
              <div v-if="Number(selected_outlet.tax_rate) !== 0 && totalTax > 0" class="__data-price">
                <h4>
                  {{ selected_outlet.tax_name }}
                  <span v-if="selected_outlet.price_tax_included">
                    ({{ $t('price_includes_tax') }})
                  </span>
                </h4>
                <v-spacer />
                <h4>
                  {{ totalTax }}
                </h4>
              </div>
            </template>
          </template>
          <template v-else>
            <div v-if="Number(selected_outlet.tax_rate) !== 0 && totalTax > 0" class="__data-price">
              <h4>
                {{ selected_outlet.tax_name }}
                <span v-if="selected_outlet.price_tax_included">
                  ({{ $t('price_includes_tax') }})
                </span>
              </h4>
              <v-spacer />
              <h4>
                {{ totalTax }}
              </h4>
            </div>
          </template>

          <!-- <div v-if="selected_outlet.url_id === 'bengongsteapantaiindahkapuk' || selected_outlet.url_id === 'bengongsteasshtaatdistrict8' || selected_outlet.url_id === 'setdemo1'" class="__data-price">
            <h4>
              Tote bag
            </h4>
            <v-spacer />
            <h4>
              3000
            </h4>
          </div> -->

          <template v-if="!$isEmpty(data_rounding) && data_rounding.is_rounded">
            <div class="__data-price">
              <h4>
                {{ $t('rounding') }}
              </h4>
              <v-spacer />
              <h4 :class="Number(data_rounding.data.rounded_amount) < 0 ? 'color-price' : ''">
                {{ data_rounding.data.rounded_amount }}
              </h4>
            </div>
          </template>

          <div class="__data-price font-weight-bold">
            <h4>
              Total
            </h4>
            <v-spacer />
            <h4 v-mask-money="!$isEmpty(data_rounding) && data_rounding.is_rounded ? data_rounding.data.total_amount : totalPrice" />
          </div>
          <template v-if="$store.state.selected_type === 'RESERVATION' && !$isEmpty($store.state.selected_outlet) && $store.state.selected_outlet.reservation.reservation_payment_terms !== 1">
            <v-divider style="border-color: #e0e0e0;" class="my-1" />
            <div class="__data-price font-weight-bold">
              <h4>
                {{ $t('down_payment') }}
              </h4>
              <v-spacer />
              <h4 v-mask-money="totalDownPaynent" />
            </div>
            <div class="__data-price font-weight-bold">
              <h4>
                Sisa pembayaran
              </h4>
              <v-spacer />
              <h4 v-mask-money="totalPrice - totalDownPaynent" />
            </div>
          </template>

          <div v-if="$store.state.selected_type === 'RESERVATION' && !$isEmpty($store.state.selected_outlet) && $store.state.selected_outlet.reservation.reservation_payment_terms !== 1" class="note-reserve mt-6">
            <div class="icon-note-reserve">
              <v-icon size="22" color="#000000">
                mdi-information-outline
              </v-icon>
            </div>
            <div class="content-note-reserve">
              <ul>
                <li>
                  Anda harus melakukan pembayaran awal sebesar
                  <span v-mask-money="totalDownPaynent" class="font-weight-bold" />
                  <span>
                    {{ $store.state.selected_outlet.reservation.reservation_payment_terms === 2 ? '(pembayaran awal + Convenience Fee)' : 'untuk biaya layanan' }}.
                  </span>
                </li>
                <li>
                  Sisa pembayaran dilakukan di kasir saat mengunjungi restoran.
                </li>
              </ul>
              <!-- <template v-if="$store.state.selected_outlet.reservation.reservation_payment_terms_amount_type === 0">
                Anda harus melakukan pembayaran awal sebesar
                <span v-mask-money="totalDownPaynent" class="font-weight-bold" />
              </template>
              <template v-else-if="$store.state.selected_outlet.reservation.reservation_payment_terms_amount_type === 1">
                Anda harus melakukan pembayaran awal sebesar
                <span class="font-weight-bold">
                  {{ Number($store.state.selected_outlet.reservation.reservation_payment_terms_amount) }}%
                </span>
                (<span v-mask-money="totalDownPaynent" class="font-weight-bold" />)
              </template>
              <template v-else>
                Anda harus melakukan pembayaran
                <span class="font-weight-bold">
                  convenience fee 1%
                </span>
              </template> -->
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <bottom-popup :action="addOrUpdate" :method="setting.method" />
    <middle-popup :action="deleteItem" :title="'Confirm'" :width="290" :message="'Are you sure to remove your order?'" />
    <div ref="menufixed" class="__menu-bottom __menu-checkout">
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
        <div class="d-flex">
          <div class="__disc-container" @click="showListDiscount">
            <div :class="[`disc-icon`, { 'active': dataInCart.discount_detail }]">
              <span>%</span>
            </div>
            <div v-if="dataInCart.discount_detail" class="disc-selected">
              {{ dataInCart.discount_detail.discount_code }}
            </div>
            <div v-else class="disc-placeholder">
              {{ $t('enter_your_promo_code_here') }}
            </div>
            <v-spacer />
            <div v-if="dataInCart.discount_detail" class="_delete-disc" @click.stop="delDisc()">
              {{ $t('delete') }}
            </div>
          </div>
        </div>
        <div class="d-flex align-center">
          <div v-if="$store.state.selected_type === 'RESERVATION' && !$isEmpty($store.state.selected_outlet) && $store.state.selected_outlet.reservation.reservation_payment_terms !== 1" class="_totalPrice">
            <h3>
              {{ $t('down_payment') }}
            </h3>
            <h2 class="title">
              <span v-mask-money="totalDownPaynent" class="font-weight-bold" />
            </h2>
          </div>
          <div v-else class="_totalPrice">
            <h3>
              Total
            </h3>
            <h2 class="title">
              <span v-mask-money="!$isEmpty(data_rounding) && data_rounding.is_rounded ? data_rounding.data.total_amount : totalPrice" class="font-weight-bold" />
              <span v-if="dataInCart.discount_detail" v-mask-money="totalPrice + Number(dataInCart.discount_detail.discount_to_amount)" class="__discount_amount" />
            </h2>
          </div>
          <v-spacer />
          <v-btn type="submit" color="primary" :disabled="disableMinimumOrder" x-large class="text-none" @click="createOrder()">
            {{ $t('pay') }}
          </v-btn>
        </div>
      </v-col>
    </div>
    <v-bottom-sheet v-model="sheet.discount" persistent :content-class="'showFull'">
      <v-sheet id="scroll-target" style="height: 100%; overflow: auto;">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h2 class="headline">
                <span class="font-weight-bold d-flex align-center">
                  <span>
                    {{ $t('voucher') }}
                  </span>
                  <v-spacer />
                  <v-icon class="black--text" @click="closeSheetDiscount()">
                    mdi-close
                  </v-icon>
                </span>
              </h2>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <v-text-field :placeholder="$t('enter_your_promo_code_here')" dense hide-details outlined clearable @input="searchVoucher" @click:clear="clearSearchData" />
            </v-col>
            <v-col v-if="discounts.length !== 0" cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h3 class="mb-3 __title-discount-list">
                {{ $t('my_voucher') }}
              </h3>
              <div v-scroll:#scroll-target="onScroll" class="list-discount" :style="{ marginBottom: selected_discount.length !== 0 ? '92px' : '0px' }">
                <template v-for="(discount, idx) in discounts">
                  <v-card :key="idx" class="card-voucher" @click="selectVoucher(idx, discount)">
                    <div class="card-detail-voucher">
                      <div class="discount-store-name">
                        {{ discount.store_name }}
                      </div>
                      <div class="discount-title">
                        {{ discount.title }}
                      </div>
                      <div class="discount-description">
                        <div class="discount-description-code">
                          {{ discount.code }}
                        </div>
                        <div class="discount-description-list" v-html="discount.discount_description" />
                      </div>
                    </div>
                  </v-card>
                </template>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="sheetDetail" persistent content-class="showFull">
      <v-sheet style="height: 100%; overflow: auto;">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="d-flex align-center">
                <h2 class="headline">
                  <span class="font-weight-bold d-flex align-center">
                    {{ $t('voucher_detail') }}
                  </span>
                </h2>
                <v-spacer />
                <v-btn text icon color="red lighten-2" @click="closeShowDetail()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid class="pa-0">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
              <div class="__bg-discount-responsive">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="360" height="128" viewBox="0 0 360 128" class="__bg-discount">
                  <defs>
                    <linearGradient id="a" x1="0.5" y1="-0.21" x2="0.695" y2="1.209" gradientUnits="objectBoundingBox">
                      <template v-if="colorTheme === 'theme-1'">
                        <stop offset="0" stop-color="#76CCFC" />
                        <stop offset="1" stop-color="#38B8FF" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-2'">
                        <stop offset="0" stop-color="#2AF598" />
                        <stop offset="1" stop-color="#009EFD" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-3'">
                        <stop offset="0" stop-color="#F6D365" />
                        <stop offset="1" stop-color="#FDA085" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-4'">
                        <stop offset="0" stop-color="#F8BB08" />
                        <stop offset="1" stop-color="#E50025" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-5'">
                        <stop offset="0" stop-color="#D70B20" />
                        <stop offset="1" stop-color="#A71F2D" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-6'">
                        <stop offset="0" stop-color="#868F96" />
                        <stop offset="1" stop-color="#596164" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-7'">
                        <stop offset="0" stop-color="#F1F21B" />
                        <stop offset="1" stop-color="#111111" />
                      </template>
                      <template v-else-if="colorTheme === 'theme-8'">
                        <stop offset="0" stop-color="#667EEA" />
                        <stop offset="1" stop-color="#764BA2" />
                      </template>
                    </linearGradient>
                    <clipPath id="c">
                      <rect class="a" width="360" height="128" />
                    </clipPath>
                    <linearGradient id="d" y1="0" x2="0.5" y2="1" xlink:href="#a" />
                  </defs>
                  <rect class="a" width="360" height="128" />
                  <text class="b" transform="translate(158 84)">
                    <tspan x="0" y="0">
                      %
                    </tspan>
                  </text>
                  <g class="c">
                    <circle class="d" cx="85" cy="85" r="85" transform="translate(-21 33)" />
                    <circle class="d" cx="85" cy="85" r="85" transform="translate(211 -72)" />
                  </g>
                </svg>
              </div>
            </v-col>
          </v-row>
        </v-container>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="d-voucher-title">
                {{ voucher.title }}
              </div>
              <div class="d-voucher-description" v-html="voucher.discount_description" />
            </v-col>
          </v-row>
        </v-container>
        <div class="__menu-bottom menu-full">
          <v-container fluid class="pa-0">
            <v-row class="ma-0">
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                <div class="wrapper-discount">
                  <div class="_totalPrice-discount">
                    <h3>
                      {{ $t('you_are_thrifty') }}
                    </h3>
                    <h2 class="title">
                      <span v-if="Number(discData.discount_amount) !== 0" v-mask-money="discData.discount_amount" class="font-weight-bold" />
                      <span v-else>
                        {{ discData.discount_rate * 100 }}%
                      </span>
                    </h2>
                  </div>
                  <v-spacer />
                  <v-btn type="submit" color="primary" :disabled="disabledHit" x-large class="text-none" @click="hitDiscount()">
                    {{ $t('use_voucher') }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-sheet>
    </v-bottom-sheet>

    <v-dialog v-model="dialog.qtyCheck" max-width="290">
      <v-card>
        <v-card-title class="headline">
          {{ $t('add_item_failed') }}
        </v-card-title>
        <v-card-text>
          {{ $t('quantity_exceeds_stock', { product: unavailable_product }) }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="grey" text class="text-none" @click="dialog.qtyCheck = false">
            {{ $t('close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.minOrderDelivery" persistent max-width="310">
      <v-card>
        <div class="img-min-order-delivery">
          <img src="@/assets/images/minimum_order_delivery.svg">
        </div>
        <v-card-text>
          <div class="title-dialog-min-order-delivery">
            Transaksimu tidak mencukupi untuk gratis ongkir :(
          </div>
          <div class="subtitle-dialog-min-order-delivery">
            Tambah menu untuk mendapatkan layanan gratis ongkir.
          </div>
        </v-card-text>
        <div class="wrap-action-min-order-delivery">
          <v-btn block color="primary" large class="text-none mb-2" @click="addMore()">
            Tambah menu
          </v-btn>
          <v-btn block color="primary" large outlined class="text-none" @click="changeShipping()">
            Ubah metode pengiriman
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.reserve_min_order" max-width="320">
      <v-card>
        <v-card-text class="pt-8">
          <div class="mb-6">
            <v-img src="@/assets/images/svg/reserve_min_order.svg" width="166" height="166" class="mx-auto" />
          </div>
          <div class="text-center">
            <div class="title-dialog mx-3">
              Minimal order belum terpenuhi :(
            </div>
            <div class="subtitle-dialog mt-4">
              Pastikan orderanmu tidak kurang dari minimal order.
            </div>
          </div>
          <v-btn block large depressed color="primary" class="text-none mt-6" @click="dialog.reserve_min_order = false">
            Ya, saya mengerti
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  hitDiscount as hitDiscountCheckout,
  getData as getDataDiscount,
  getDataDetail as getDataDetailDiscount
} from '@/api/discount'
import {
  validateMaterial
} from '@/api/product'
import { checkRounding } from '@/api/setting'
import { mapGetters } from 'vuex'
import { debounce } from 'debounce'
import bottomPopup from '@/components/modules/popup/BottomPopup'
import middlePopup from '@/components/modules/popup/MiddlePopup'
export default {
  components: {
    bottomPopup,
    middlePopup
  },
  data() {
    return {
      data_rounding: {},
      unavailable_product: '',
      dialog: {
        qtyCheck: false,
        minOrderDelivery: false,
        reserve_min_order: false
      },
      extra_charge: 0,
      setting: {
        AddShow: false,
        method: '',
        ShowPopup: false,
        idItem: 0
      },
      item_tax: [],
      item_price: [],
      item_service: [],
      totalTax: 0,
      totalPriceItem: 0,
      totalPrice: 0,
      totalPriceWithoutShipping: 0,
      totalDownPaynent: 0,
      totalConvenienceFee: 0,
      totalExtraCharge: 0,
      selected_outlet: {},
      dataInCart: {},
      sheet: {
        discount: false
      },
      discounts: [],
      selected_discount: [],
      discData: {},
      settingScroll: false,
      params: {
        page: 1,
        per_page: 10
      },
      search_text: '',
      searching: false,
      dataHitDiscount: {},
      sheetDetail: false,
      voucher: {},
      disabledHit: true,
      disableMinimumOrder: false,
      heightMenu: 0,
      temp_cart: {}
    }
  },
  computed: {
    formatReserveDate() {
      const d = new Date(this.dataInCart.reserve_date)
      var day = d.getDay()
      const date = d.getDate()
      var month = d.getMonth()
      const year = d.getFullYear()

      switch (day) {
        case 0: day = this.$t('date.sunday'); break
        case 1: day = this.$t('date.monday'); break
        case 2: day = this.$t('date.tuesday'); break
        case 3: day = this.$t('date.wednesday'); break
        case 4: day = this.$t('date.thursday'); break
        case 5: day = this.$t('date.friday'); break
        case 6: day = this.$t('date.saturday'); break
      }

      switch (month) {
        case 0: month = this.$t('date.january'); break
        case 1: month = this.$t('date.february'); break
        case 2: month = this.$t('date.march'); break
        case 3: month = this.$t('date.april'); break
        case 4: month = this.$t('date.may'); break
        case 5: month = this.$t('date.june'); break
        case 6: month = this.$t('date.july'); break
        case 7: month = this.$t('date.august'); break
        case 8: month = this.$t('date.september'); break
        case 9: month = this.$t('date.october'); break
        case 10: month = this.$t('date.november'); break
        case 11: month = this.$t('date.december'); break
      }

      return day + ', ' + date + ' ' + month + ' ' + year
    },
    colorTheme() {
      let color = 'theme-1'
      if (this.$store.state.selected_store) {
        if (this.$store.state.selected_store.setting) {
          if (this.$store.state.selected_store.setting.online_color_id === 1) {
            color = 'theme-1'
          } else if (this.$store.state.selected_store.setting.online_color_id === 2) {
            color = 'theme-2'
          } else if (this.$store.state.selected_store.setting.online_color_id === 3) {
            color = 'theme-3'
          } else if (this.$store.state.selected_store.setting.online_color_id === 4) {
            color = 'theme-4'
          } else if (this.$store.state.selected_store.setting.online_color_id === 5) {
            color = 'theme-5'
          } else if (this.$store.state.selected_store.setting.online_color_id === 6) {
            color = 'theme-6'
          } else if (this.$store.state.selected_store.setting.online_color_id === 7) {
            color = 'theme-7'
          } else if (this.$store.state.selected_store.setting.online_color_id === 8) {
            color = 'theme-8'
          }
        }
      }
      return color
    },
    ...mapGetters(['checkUser'])
  },
  watch: {
    totalPrice: {
      handler: async function(newItem) {
        if (this.$store.state.selected_type === 'DELIVERY' && this.dataInCart.shipping_delivery_type === 1) {
          if (!this.$isEmpty(this.selected_outlet)) {
            if (newItem < Number(this.selected_outlet.delivery.minimum_order)) {
              this.dataInCart.shipping_cost = this.dataInCart.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
              if (this.dataInCart.item.length !== 0) {
                this.dialog.reserve_min_order = false
                this.dialog.minOrderDelivery = false
                this.disableMinimumOrder = false
              }
            } else {
              if (this.totalPriceItem < Number(this.$store.state.selected_outlet.delivery.minimum_order)) {
                if (this.dataInCart.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
                  this.dataInCart.shipping_cost = (this.dataInCart.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius
                } else {
                  this.dataInCart.shipping_cost = this.dataInCart.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius
                }
              } else if (this.dataInCart.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
                this.dataInCart.shipping_cost = (this.dataInCart.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius
              } else {
                this.dataInCart.shipping_cost = 0
              }
              if (this.dataInCart.item.length !== 0) {
                this.dialog.reserve_min_order = false
                this.dialog.minOrderDelivery = false
                this.disableMinimumOrder = false
              }
            }
            this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
          } else {
            if (this.dataInCart.item.length !== 0) {
              this.dialog.reserve_min_order = false
              this.dialog.minOrderDelivery = true
              this.disableMinimumOrder = true
            }
          }
        } else if (this.$store.state.selected_type === 'RESERVATION' && !this.$isEmpty(this.selected_outlet)) {
          await this.CheckRound(newItem)
          if (this.data_rounding.is_rounded) {
            if (Number(this.data_rounding.data.total_amount) < Number(this.selected_outlet.reservation.minimum_order_amount)) {
              if (this.dataInCart.item.length !== 0) {
                this.dialog.reserve_min_order = true
                this.dialog.minOrderDelivery = false
                this.disableMinimumOrder = true
              }
            } else {
              if (this.dataInCart.item.length !== 0) {
                this.dialog.reserve_min_order = false
                this.dialog.minOrderDelivery = false
                this.disableMinimumOrder = false
              }
            }
          } else {
            if (newItem < Number(this.selected_outlet.reservation.minimum_order_amount)) {
              if (this.dataInCart.item.length !== 0) {
                this.dialog.reserve_min_order = true
                this.dialog.minOrderDelivery = false
                this.disableMinimumOrder = true
              }
            } else {
              if (this.dataInCart.item.length !== 0) {
                this.dialog.reserve_min_order = false
                this.dialog.minOrderDelivery = false
                this.disableMinimumOrder = false
              }
            }
          }
        } else {
          if (this.dataInCart.item.length !== 0) {
            this.dialog.reserve_min_order = false
            this.dialog.minOrderDelivery = false
            this.disableMinimumOrder = false
          }
        }
      }
    },
    dataInCart: {
      handler: function(newItem, oldItem) {
        if (newItem) {
          if (newItem.item.length === 0) {
            if (this.$store.state.selected_type === 'RESERVATION') {
              this.$router.push({ name: 'reservation_menu' }).catch(() => {})
            } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
              this.$router.push({ name: 'take_away_menu' }).catch(() => {})
            } else if (this.$store.state.selected_type === 'DELIVERY') {
              this.$router.push({ name: 'delivery_menu' }).catch(() => {})
            } else if (this.$store.state.selected_type === 'DINE-IN') {
              this.$router.push({ name: 'dinein_menu' }).catch(() => {})
            }
            if (typeof newItem.discount_voucher_id !== 'undefined' && newItem.discount_voucher_id) {
              this.delDisc()
            }
          }
        }
      },
      deep: true
    }
  },
  mounted() {
    this.heightMenu = this.$refs.menufixed.clientHeight
    this.loadDataCart()
    this.$root.$on('CloseAddPopup', (dataMenu) => {
      this.setting.AddShow = dataMenu
    })
    this.$root.$on('ClosePopup', (dataMenu) => {
      this.setting.ShowPopup = dataMenu
    })
  },
  methods: {
    addMore() {
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$router.push({ name: 'reservation_menu' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$router.push({ name: 'take_away_menu' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.$router.push({ name: 'delivery_menu' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$router.push({ name: 'dinein_menu' }).catch(() => {})
      }
    },
    changeShipping() {
      this.$router.push({ name: 'delivery_method' }).catch(() => {})
    },
    async delDisc() {
      this.$delete(this.dataInCart, 'discount_voucher_id')
      this.$delete(this.dataInCart, 'discount_detail')
      if (this.$store.state.selected_type === 'RESERVATION') {
        await this.$store.dispatch('saveDataCartReservation', this.dataInCart)
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        await this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        await this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        await this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
      }
      this.loadDataCart()
    },
    async hitDiscount(discount_id, checkCart = true) {
      this.$store.state.loading = true
      this.dataHitDiscount = { ...this.dataInCart }
      if (discount_id) {
        this.dataHitDiscount.discount_id = discount_id
      } else {
        this.dataHitDiscount.discount_id = this.discData.id
      }
      this.dataHitDiscount.remark = this.$store.state.selected_type
      this.$delete(this.dataInCart, 'discount_voucher_id')
      this.$delete(this.dataInCart, 'discount_detail')
      try {
        const { data } = await hitDiscountCheckout(this.dataHitDiscount)
        this.$store.state.loading_axios = false
        if (discount_id) {
          this.dataInCart.discount_voucher_id = discount_id
        } else {
          this.dataInCart.discount_voucher_id = this.discData.id
        }
        this.$set(this.dataInCart, 'discount_detail', data.data)
        if (this.$store.state.selected_type === 'RESERVATION') {
          await this.$store.dispatch('saveDataCartReservation', this.dataInCart)
        } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          await this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          await this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
        } else if (this.$store.state.selected_type === 'DINE-IN') {
          await this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
        }
        this.sheet.discount = false
        this.sheetDetail = false
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain

          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
      if (checkCart) {
        this.loadDataCart(false)
      }
      this.$store.state.loading = false
    },
    onScroll() {
      if (this.settingScroll === false) {
        if ((window.innerHeight + window.scrollY + 150) >= document.body.offsetHeight) {
          this.loadDiscount()
        }
      }
    },
    selectDiscount(idx, item) {
      this.discData = {}
      this.selected_discount = []
      this.$set(this.selected_discount, idx, true)
      this.discData = item
    },
    closeSheetDiscount() {
      this.sheet.discount = false
    },
    showListDiscount() {
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain
      if (tmii_outlet.indexOf(url_id) !== -1) {
        this.selected_discount = []
        this.sheet.discount = true
        this.loadDiscount()
      } else {
        if (this.checkUser.auth_by === 'BASIC' || this.checkUser.auth_by === 'GUEST') {
          this.selected_discount = []
          this.sheet.discount = true
          this.loadDiscount()
        } else {
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: 'checkout' }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: 'checkout' }}).catch(() => {})
          }
        }
      }
    },
    async loadDiscount() {
      let remark = ''
      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        remark = 'use_take_away'
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        remark = 'use_delivery'
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        remark = 'use_dine_in'
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        remark = 'use_reservation'
      }
      var _params = {
        page: this.params.page++,
        per_page: this.params.per_page,
        search_text: 1,
        search_operator: '=',
        search_column: remark
      }
      try {
        const { data } = await getDataDiscount(_params)
        this.settingScroll = (data.data.length < this.params.per_page)
        this.$store.state.loading_axios = false
        for (var i in data.data) {
          this.discounts.push(data.data[i])
        }
      } catch (e) {
        this.discounts = []
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
          const tmii_outlet = this.$store.state.store_tmii
          const url_id = this.$store.state.url_domain
          if (tmii_outlet.indexOf(url_id) !== -1) {
            this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
          } else {
            this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
          }
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async loadDataCart(checkDisc = true) {
      const selected_type = this.$store.state.selected_type
      if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type))) {
        this.dataInCart = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type))
      }
      if (typeof this.dataInCart.discount_voucher_id !== 'undefined' && checkDisc) {
        await this.hitDiscount(this.dataInCart.discount_voucher_id, false)
      }
      if (this.$store.state.selected_outlet && !this.$isEmpty(this.$store.state.selected_outlet)) {
        this.selected_outlet = this.$store.state.selected_outlet
      }

      this.extra_charge = Number(this.selected_outlet.service_charge_rate)

      if (this.dataInCart.item) {
        for (const i in this.dataInCart.item) {
          if (this.dataInCart.item[i].non_taxable === 0) {
            this.item_tax[i] = this.dataInCart.item[i].sub_total
          }
          if (this.dataInCart.item[i].non_service_charge === 0) {
            this.item_service[i] = this.dataInCart.item[i].sub_total
          }
          this.item_price[i] = this.dataInCart.item[i].sub_total
        }
      }
      this.sumPrice(this.item_price, this.item_tax, this.item_service)
    },
    showPopupNote(idx, method) {
      this.setting.AddShow = !this.setting.AddShow
      this.setting.idItem = idx
      if (method === 'update') {
        this.setting.method = 'update'
      } else if (method === 'create') {
        this.setting.method = 'create'
      }
      this.$root.$emit('ShowAddPopup', this.setting)
    },
    addOrUpdate(idx, data) {
      var obj
      var selected_type = this.$store.state.selected_type
      obj = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type))
      if (this.setting.method === 'create') {
        obj.item[idx] = data
      } else if (this.setting.method === 'update') {
        obj.item[idx] = data
      }
      this.setting.AddShow = false
      this.$root.$emit('CloseAddPopup', this.setting.AddShow)
      if (selected_type === 'RESERVATION') {
        this.$store.dispatch('saveDataCartReservation', obj)
      } else if (selected_type === 'OL-TAKE-AWAY') {
        this.$store.dispatch('saveDataCartTakeAway', obj)
      } else if (selected_type === 'DELIVERY') {
        this.$store.dispatch('saveDataCartDelivery', obj)
      } else if (selected_type === 'DINE-IN') {
        this.$store.dispatch('saveDataCartDineIn', obj)
      }
      this.dataInCart = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type))
    },
    goBack() {
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$router.push({ name: 'reservation_menu' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$router.push({ name: 'take_away_menu' }).catch(() => {})
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.$store.state.data_cart_delivery.shipping_delivery_type === 1) {
          this.$router.push({ name: 'delivery_time' }).catch(() => {})
        } else {
          this.$router.push({ name: 'delivery_method' }).catch(() => {})
        }
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$router.push({ name: 'dinein_menu' }).catch(() => {})
      }
    },
    async validateStockMaterial() {
      const obj = {
        valid: true,
        message: ''
      }
      try {
        const cart_item = [...this.dataInCart.item]
        this.temp_cart.item = [...cart_item]
        await validateMaterial(this.temp_cart)
        this.$store.state.loading_axios = false
        return obj
      } catch (e) {
        delete this.temp_cart.item
        obj.valid = false
        obj.message = e.string
        return obj
      }
    },
    async plus(idx) {
      let product_available = true
      let unavailable_product = ''
      const _selected_type = this.$store.state.selected_type
      const _storage = '_data_cart_' + _selected_type
      if (this.dataInCart.item[idx].product_combo_id) {
        for (var i = 0; i < this.dataInCart.item[idx].product_combo_items.length; i++) {
          if (this.dataInCart.item[idx].product_combo_items[i].track_inventory) {
            if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
              if (this.dataInCart.item[idx].product_combo_items[i].variant_id) {
                const stock_incart = this.$stockCart(this.dataInCart.item[idx].product_combo_items[i].variant_id, _storage, 'variant')
                if (this.dataInCart.item[idx].product_combo_items[i].stock_qty - this.dataInCart.item[idx].product_combo_items[i].hold_qty < this.dataInCart.item[idx].product_combo_items[i].qty + stock_incart) {
                  product_available = false
                  unavailable_product = this.dataInCart.item[idx].product_combo_items[i].name
                  break
                }
              } else {
                const stock_incart = this.$stockCart(this.dataInCart.item[idx].product_combo_items[i].id, _storage)
                if (this.dataInCart.item[idx].product_combo_items[i].stock_qty - this.dataInCart.item[idx].product_combo_items[i].hold_qty < this.dataInCart.item[idx].product_combo_items[i].qty + stock_incart) {
                  product_available = false
                  unavailable_product = this.dataInCart.item[idx].product_combo_items[i].name
                  break
                }
              }
            }
          }
        }
      } else {
        if (this.dataInCart.item[idx].track_inventory) {
          if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
            if (this.dataInCart.item[idx].product_variant_id) {
              const stock_incart = this.$stockCart(this.dataInCart.item[idx].product_variant_id, _storage, 'variant')
              if (Number(this.dataInCart.item[idx].stock_qty) - Number(this.dataInCart.item[idx].hold_qty) < 1 + stock_incart) {
                product_available = false
                unavailable_product = this.dataInCart.item[idx].name
              }
            } else {
              const stock_incart = this.$stockCart(this.dataInCart.item[idx].product_id, _storage)
              if (Number(this.dataInCart.item[idx].stock_qty) - Number(this.dataInCart.item[idx].hold_qty) < 1 + stock_incart) {
                product_available = false
                unavailable_product = this.dataInCart.item[idx].name
              }
            }
          }
        } else {
          if (!this.checkStockMaterials(this.dataInCart.item[idx])) {
            product_available = false
            unavailable_product = this.dataInCart.item[idx].name
          }
        }
      }

      if (product_available) {
        // this.dataInCart.item[idx].qty = this.dataInCart.item[idx].qty + 1
        // var price
        // var selected_type = this.$store.state.selected_type
        // price = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].sell_price
        // if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].addons.length > 0) {
        //   const arrAddons = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].addons
        //   for (let i = 0; i < arrAddons.length; i++) {
        //     price = price + (arrAddons[i].product_addon_price * 1)
        //   }
        // }
        // if (this.dataInCart.item[idx].materials.length > 0) {
        //   for (let i = 0; i < this.dataInCart.item[idx].materials.length; i++) {
        //     this.dataInCart.item[idx].materials[i].qty_in_cart = Number(this.dataInCart.item[idx].materials[i].qty_in_cart) + Number(this.dataInCart.item[idx].materials[i].qty)
        //   }
        // }
        // this.item_price[idx] = parseFloat(price) + this.item_price[idx]
        // if (this.dataInCart.item[idx].non_taxable === 0) {
        //   this.item_tax[idx] = parseFloat(price) + this.item_tax[idx]
        // }
        // if (this.dataInCart.item[idx].non_service_charge === 0) {
        //   this.item_service[idx] = parseFloat(price) + this.item_service[idx]
        // }
        // this.dataInCart.item[idx].sub_total = this.item_price[idx]
        // if (this.dataInCart.discount_voucher_id) {
        //   const discount_id = this.dataInCart.discount_voucher_id
        //   await this.hitDiscount(discount_id)
        // }
        // this.sumPrice(this.item_price, this.item_tax, this.item_service)
        // if (selected_type === 'RESERVATION') {
        //   this.$store.dispatch('saveDataCartReservation', this.dataInCart)
        // } else if (selected_type === 'OL-TAKE-AWAY') {
        //   this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
        // } else if (selected_type === 'DELIVERY') {
        //   this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
        // } else if (selected_type === 'DINE-IN') {
        //   this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
        // }

        this.dataInCart.item[idx].qty = this.dataInCart.item[idx].qty + 1
        let valid = true
        await this.validateStockMaterial().then((data) => {
          valid = data.valid
          this.dialog.qtyCheck = !data.valid
          this.unavailable_product = data.message
          if (!data.valid) {
            this.dataInCart.item[idx].qty = this.dataInCart.item[idx].qty - 1
            return
          }
        })
        if (valid) {
          var price
          var selected_type = this.$store.state.selected_type
          price = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].sell_price
          if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].addons.length > 0) {
            const arrAddons = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].addons
            for (let i = 0; i < arrAddons.length; i++) {
              price = price + (arrAddons[i].product_addon_price * 1)
            }
          }
          if (this.dataInCart.item[idx].materials.length > 0) {
            for (let i = 0; i < this.dataInCart.item[idx].materials.length; i++) {
              this.dataInCart.item[idx].materials[i].qty_in_cart = Number(this.dataInCart.item[idx].materials[i].qty_in_cart) + Number(this.dataInCart.item[idx].materials[i].qty)
            }
          }
          this.item_price[idx] = parseFloat(price) + this.item_price[idx]
          if (this.dataInCart.item[idx].non_taxable === 0) {
            this.item_tax[idx] = parseFloat(price) + this.item_tax[idx]
          }
          if (this.dataInCart.item[idx].non_service_charge === 0) {
            this.item_service[idx] = parseFloat(price) + this.item_service[idx]
          }
          this.dataInCart.item[idx].sub_total = this.item_price[idx]
          if (this.dataInCart.discount_voucher_id) {
            const discount_id = this.dataInCart.discount_voucher_id
            await this.hitDiscount(discount_id)
          }
          this.sumPrice(this.item_price, this.item_tax, this.item_service)
          if (selected_type === 'RESERVATION') {
            this.$store.dispatch('saveDataCartReservation', this.dataInCart)
          } else if (selected_type === 'OL-TAKE-AWAY') {
            this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
          } else if (selected_type === 'DELIVERY') {
            this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
          } else if (selected_type === 'DINE-IN') {
            this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
          }
        }
      } else {
        this.unavailable_product = unavailable_product
        this.dialog.qtyCheck = true
      }
    },
    async minus(idx) {
      if ((this.dataInCart.item[idx].qty - 1) === 0) {
        this.setting.ShowPopup = !this.setting.ShowPopup
        this.setting.idItem = idx
        this.$root.$emit('ShowPopup', this.setting)
      } else {
        this.dataInCart.item[idx].qty = this.dataInCart.item[idx].qty - 1
        var price
        var selected_type = this.$store.state.selected_type
        price = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].sell_price
        if (JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].addons.length > 0) {
          const arrAddons = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_' + selected_type)).item[idx].addons
          for (let i = 0; i < arrAddons.length; i++) {
            price = price + (arrAddons[i].product_addon_price * 1)
          }
        }
        if (this.dataInCart.item[idx].materials.length > 0) {
          for (let i = 0; i < this.dataInCart.item[idx].materials.length; i++) {
            this.dataInCart.item[idx].materials[i].qty_in_cart = this.dataInCart.item[idx].materials[i].qty_in_cart - this.dataInCart.item[idx].materials[i].qty
          }
        }
        this.item_price[idx] = this.item_price[idx] - parseFloat(price)
        if (this.dataInCart.item[idx].non_taxable === 0) {
          this.item_tax[idx] = this.item_tax[idx] - parseFloat(price)
        }
        if (this.dataInCart.item[idx].non_service_charge === 0) {
          this.item_service[idx] = this.item_service[idx] - parseFloat(price)
        }
        this.dataInCart.item[idx].sub_total = this.item_price[idx]
        if (this.dataInCart.discount_voucher_id) {
          const discount_id = this.dataInCart.discount_voucher_id
          await this.hitDiscount(discount_id)
        }
        this.sumPrice(this.item_price, this.item_tax, this.item_service)
        if (selected_type === 'RESERVATION') {
          this.$store.dispatch('saveDataCartReservation', this.dataInCart)
        } else if (selected_type === 'OL-TAKE-AWAY') {
          this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
        } else if (selected_type === 'DELIVERY') {
          this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
        } else if (selected_type === 'DINE-IN') {
          this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
        }
      }
    },
    async deleteItem(idx) {
      this.setting.ShowPopup = false
      this.$root.$emit('ClosePopup', this.setting.ShowPopup)
      if (!this.$isEmpty(this.dataInCart) && typeof this.dataInCart.item !== 'undefined') {
        if (this.item_price.length > 0) {
          await this.item_price.splice(idx, 1)
        }
        if (this.dataInCart.item[idx].non_taxable === 0) {
          await this.item_tax.splice(idx, 1)
        }
        if (this.dataInCart.item[idx].non_service_charge === 0) {
          await this.item_service.splice(idx, 1)
        }
        if (this.dataInCart.item.length > 0) {
          await this.dataInCart.item.splice(idx, 1)
        }
        if (this.dataInCart.item.length !== 0) {
          if (this.dataInCart.discount_voucher_id) {
            const discount_id = this.dataInCart.discount_voucher_id
            this.hitDiscount(discount_id)
          }
        }
        this.sumPrice(this.item_price, this.item_tax, this.item_service)
      }
      this.item_price = this.item_price.filter(val => val)
      this.item_tax = this.item_tax.filter(val => val)
      this.item_service = this.item_service.filter(val => val)
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$store.dispatch('saveDataCartReservation', this.dataInCart)
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
      }
    },
    sumPrice(obj, objTax, objService) {
      // const linkAllinolsera2 = [
      //   'allinolsera2',
      //   'jakartatest'
      // ]

      // const store_link = this.$store.state.url_domain

      var sum = 0
      for (var el in obj) {
        if (obj.hasOwnProperty(el)) {
          sum += parseFloat(obj[el])
        }
      }

      this.totalPriceItem = sum

      if (this.dataInCart.discount_detail) {
        this.totalPrice = sum - this.dataInCart.discount_detail.discount_to_amount
      } else {
        this.totalPrice = sum
      }

      var sumService = 0
      for (var serviceEl in objService) {
        if (objService.hasOwnProperty(serviceEl)) {
          sumService += parseFloat(objService[serviceEl])
        }
      }

      let trans_fee = 0
      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        trans_fee = Number(this.selected_outlet.setting.trans_fee_rate_takeaway)
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        trans_fee = Number(this.selected_outlet.setting.trans_fee_rate_delivery)
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        trans_fee = Number(this.selected_outlet.setting.trans_fee_rate)
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        trans_fee = Number(this.selected_outlet.setting.trans_fee_rate_reservation)
      }

      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        // this.totalConvenienceFee = Math.round(sum * 1) / 100
        // request tim (RIKO, KO LAW, MAS ROY CF = SUBTOTAL - DISKON)
        if (trans_fee > 0) {
          if (this.dataInCart.discount_detail) {
            if (sum - this.dataInCart.discount_detail.discount_to_amount <= 0) {
              this.totalConvenienceFee = 500
            } else {
              this.totalConvenienceFee = (Math.round((sum - this.dataInCart.discount_detail.discount_to_amount) * trans_fee)) < 500 ? 500 : (Math.round((sum - this.dataInCart.discount_detail.discount_to_amount) * trans_fee))
            }
          } else {
            this.totalConvenienceFee = (Math.round(sum * 1) / 100) < 500 ? 500 : (Math.round(sum * trans_fee))
          }
        } else {
          this.totalConvenienceFee = 0
        }

        this.totalPrice = this.totalPrice + this.totalConvenienceFee

        if (this.selected_outlet.pos_take_away_with_service_charge) {
          if (this.dataInCart.discount_detail) {
            if (sumService - this.dataInCart.discount_detail.discount_to_amount <= 0) {
              this.totalExtraCharge = 0
            } else {
              this.totalExtraCharge = Math.round(((sumService - (this.selected_outlet.pos_tax_before_discount ? 0 : this.dataInCart.discount_detail.discount_to_amount)) * this.extra_charge) * 100) / 100
              this.totalPrice = this.totalPrice + (((this.selected_outlet.price_service_charge_included ? 0 : sumService) - (this.selected_outlet.pos_tax_before_discount ? 0 : this.dataInCart.discount_detail.discount_to_amount)) * this.extra_charge)
            }
          } else {
            this.totalExtraCharge = Math.round((sumService * this.extra_charge) * 100) / 100
            this.totalPrice = this.totalPrice + ((this.selected_outlet.price_service_charge_included ? 0 : sumService) * this.extra_charge)
          }
          // this.totalExtraCharge = Math.round((this.totalPrice * this.extra_charge) * 100) / 100
          // this.totalPrice = this.totalPrice + (this.totalPrice * this.extra_charge)
        }
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        // this.totalConvenienceFee = Math.round(sum * 1) / 100
        // request tim (RIKO, KO LAW, MAS ROY CF = SUBTOTAL - DISKON)
        if (trans_fee > 0) {
          if (this.dataInCart.discount_detail) {
            if (sum - this.dataInCart.discount_detail.discount_to_amount <= 0) {
              this.totalConvenienceFee = 500
            } else {
              this.totalConvenienceFee = (Math.round((sum - this.dataInCart.discount_detail.discount_to_amount) * trans_fee)) < 500 ? 500 : (Math.round((sum - this.dataInCart.discount_detail.discount_to_amount) * trans_fee))
            }
          } else {
            this.totalConvenienceFee = (Math.round(sum * 1) / 100) < 500 ? 500 : (Math.round(sum * trans_fee))
          }
        } else {
          this.totalConvenienceFee = 0
        }

        this.totalPrice = this.totalPrice + this.totalConvenienceFee

        if (this.selected_outlet.pos_food_delivery_with_service_charge) {
          if (this.dataInCart.discount_detail) {
            if (sumService - this.dataInCart.discount_detail.discount_to_amount <= 0) {
              this.totalExtraCharge = 0
            } else {
              this.totalExtraCharge = Math.round(((sumService - (this.selected_outlet.pos_tax_before_discount ? 0 : this.dataInCart.discount_detail.discount_to_amount)) * this.extra_charge) * 100) / 100
              this.totalPrice = this.totalPrice + (((this.selected_outlet.price_service_charge_included ? 0 : sumService) - (this.selected_outlet.pos_tax_before_discount ? 0 : this.dataInCart.discount_detail.discount_to_amount)) * this.extra_charge)
            }
          } else {
            this.totalExtraCharge = Math.round((sumService * this.extra_charge) * 100) / 100
            this.totalPrice = this.totalPrice + ((this.selected_outlet.price_service_charge_included ? 0 : sumService) * this.extra_charge)
          }
          // this.totalExtraCharge = Math.round((this.totalPrice * this.extra_charge) * 100) / 100
          // this.totalPrice = this.totalPrice + (this.totalPrice * this.extra_charge)
        }
      } else {
        if (this.$store.state.selected_type === 'RESERVATION') {
          // request tim (RIKO, KO LAW, MAS ROY CF = SUBTOTAL - DISKON)
          if (trans_fee > 0) {
            if (this.dataInCart.discount_detail) {
              if (sum - this.dataInCart.discount_detail.discount_to_amount <= 0) {
                this.totalConvenienceFee = 500
              } else {
                this.totalConvenienceFee = (Math.round((sum - this.dataInCart.discount_detail.discount_to_amount) * 1) / 100) < 500 ? 500 : (Math.round((sum - this.dataInCart.discount_detail.discount_to_amount) * trans_fee))
              }
            } else {
              this.totalConvenienceFee = (Math.round(sum * 1) / 100) < 500 ? 500 : (Math.round(sum * trans_fee))
            }
          } else {
            this.totalConvenienceFee = 0
          }
          this.totalPrice = this.totalPrice + this.totalConvenienceFee
        }
        if (this.dataInCart.discount_detail) {
          if (sumService - this.dataInCart.discount_detail.discount_to_amount <= 0) {
            this.totalExtraCharge = 0
          } else {
            this.totalExtraCharge = Math.round(((sumService - (this.selected_outlet.pos_tax_before_discount ? 0 : this.dataInCart.discount_detail.discount_to_amount)) * this.extra_charge) * 100) / 100
            this.totalPrice = this.totalPrice + (((this.selected_outlet.price_service_charge_included ? 0 : sumService) - (this.selected_outlet.pos_tax_before_discount ? 0 : this.dataInCart.discount_detail.discount_to_amount)) * this.extra_charge)
          }
        } else {
          this.totalExtraCharge = Math.round((sumService * this.extra_charge) * 100) / 100
          this.totalPrice = this.totalPrice + ((this.selected_outlet.price_service_charge_included ? 0 : sumService) * this.extra_charge)
        }
        // this.totalExtraCharge = Math.round((this.totalPrice * this.extra_charge) * 100) / 100
        // this.totalPrice = this.totalPrice + (this.totalPrice * this.extra_charge)
      }

      var sumTax = 0
      for (var taxEl in objTax) {
        if (objTax.hasOwnProperty(taxEl)) {
          sumTax += parseFloat(objTax[taxEl])
        }
      }

      // rumus pajak untuk harga sudah termasuk pajak
      // taxAmount = orderAmount - (orderAmount / (1 + taxRate))

      // if (linkAllinolsera2.indexOf(store_link) !== -1) {
      if (this.selected_outlet.pos_tax_before_discount) {
        if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          if (this.selected_outlet.pos_take_away_no_tax !== 1) {
            if (this.totalExtraCharge > 0) {
              if (this.selected_outlet.price_tax_included) {
                this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
              } else {
                this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
              }
            } else {
              if (this.selected_outlet.price_tax_included) {
                this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
              } else {
                this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
              }
            }
          }
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          if (this.selected_outlet.pos_food_delivery_with_tax) {
            console.log(this.dataInCart.shipping_delivery_type === 1)
            if (this.totalExtraCharge > 0) {
              if (this.selected_outlet.price_tax_included) {
                this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
              } else {
                this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
              }
            } else {
              if (this.selected_outlet.price_tax_included) {
                this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
              } else {
                this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
              }
            }
          }
        } else {
          if (this.totalExtraCharge > 0) {
            if (this.selected_outlet.price_tax_included) {
              this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
            } else {
              this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
            }
          } else {
            if (this.selected_outlet.price_tax_included) {
              this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
            } else {
              this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
            }
          }
        }
      } else {
        if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
          if (this.selected_outlet.pos_take_away_no_tax !== 1) {
            if (this.dataInCart.discount_detail) {
              if (Number(this.dataInCart.discount_detail.discount_to_amount) < 0) {
                if (this.totalExtraCharge > 0) {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                } else {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                }
              } else {
                if (this.totalExtraCharge > 0) {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                } else {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                }
              }
            } else {
              if (this.totalExtraCharge > 0) {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              } else {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              }
            }
          }
        } else if (this.$store.state.selected_type === 'DELIVERY') {
          if (this.selected_outlet.pos_food_delivery_with_tax) {
            if (this.dataInCart.discount_detail) {
              if (Number(this.dataInCart.discount_detail.discount_to_amount) < 0) {
                if (this.dataInCart.shipping_delivery_type === 1) {
                  if (this.totalExtraCharge > 0) {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + this.dataInCart.shipping_cost + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + this.dataInCart.shipping_cost + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round(((sumTax + this.dataInCart.shipping_cost + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  } else {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + this.dataInCart.shipping_cost) - ((sumTax + this.dataInCart.shipping_cost) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round(((sumTax + this.dataInCart.shipping_cost) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  }
                } else {
                  if (this.totalExtraCharge > 0) {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  } else {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  }
                }
              } else {
                if (this.dataInCart.shipping_delivery_type === 1) {
                  if (this.totalExtraCharge > 0) {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  } else {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) : 0) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) : 0) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount + this.dataInCart.shipping_cost) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  }
                } else {
                  if (this.totalExtraCharge > 0) {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  } else {
                    if (this.selected_outlet.price_tax_included) {
                      this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                    } else {
                      this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                    }
                  }
                }
              }
            } else {
              if (this.dataInCart.shipping_delivery_type === 1) {
                if (this.totalExtraCharge > 0) {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax + this.dataInCart.shipping_cost) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - (((sumTax + this.dataInCart.shipping_cost) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((((sumTax + this.dataInCart.shipping_cost) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                } else {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + this.dataInCart.shipping_cost) - ((sumTax + this.dataInCart.shipping_cost) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round(((sumTax + this.dataInCart.shipping_cost) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                }
              } else {
                if (this.totalExtraCharge > 0) {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                } else {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                }
              }
            }
          } else {
            if (this.dataInCart.discount_detail) {
              if (Number(this.dataInCart.discount_detail.discount_to_amount) < 0) {
                if (this.totalExtraCharge > 0) {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                } else {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                }
              } else {
                if (this.totalExtraCharge > 0) {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                } else {
                  if (this.selected_outlet.price_tax_included) {
                    this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                  } else {
                    this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                  }
                }
              }
            } else {
              if (this.totalExtraCharge > 0) {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              } else {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              }
            }
          }
        } else {
          if (this.dataInCart.discount_detail) {
            if (Number(this.dataInCart.discount_detail.discount_to_amount) < 0) {
              // this.totalTax = 0
              if (this.totalExtraCharge > 0) {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              } else {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              }
            } else {
              if (this.totalExtraCharge > 0) {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              } else {
                if (this.selected_outlet.price_tax_included) {
                  this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) - (((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
                } else {
                  this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
                }
              }
            }
          } else {
            if (this.totalExtraCharge > 0) {
              if (this.selected_outlet.price_tax_included) {
                this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) - ((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) / (1 + Number(this.selected_outlet.tax_rate)))) : 0
              } else {
                this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
              }
            } else {
              if (this.selected_outlet.price_tax_included) {
                this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
              } else {
                this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
              }
            }
          }
        }
      }
      // } else {
      //   if (this.$store.state.selected_type === 'OL-TAKE-AWAY' || this.$store.state.selected_type === 'DELIVERY') {
      //     if (this.selected_outlet.pos_take_away_no_tax !== 1) {
      //       if (this.dataInCart.discount_detail) {
      //         if (Number(this.dataInCart.discount_detail.discount_to_amount) < 0) {
      //           // this.totalTax = 0
      //           if (this.totalExtraCharge > 0) {
      //             this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //           } else {
      //             // this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //             this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
      //           }
      //         } else {
      //           if (this.totalExtraCharge > 0) {
      //             this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //           } else {
      //             this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //           }
      //         }
      //       } else {
      //         if (this.totalExtraCharge > 0) {
      //           this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //         } else {
      //           // this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //           this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
      //         }
      //       }
      //     }
      //   } else {
      //     if (this.dataInCart.discount_detail) {
      //       if (Number(this.dataInCart.discount_detail.discount_to_amount) < 0) {
      //         // this.totalTax = 0
      //         if (this.totalExtraCharge > 0) {
      //           this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //         } else {
      //           // this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //           this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
      //         }
      //       } else {
      //         if (this.totalExtraCharge > 0) {
      //           this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? ((sumTax - this.dataInCart.discount_detail.discount_to_amount) + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) : 0 + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //         } else {
      //           this.totalTax = Math.round((((sumTax - this.dataInCart.discount_detail.discount_to_amount) > 0 ? (sumTax - this.dataInCart.discount_detail.discount_to_amount) : 0) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //         }
      //       }
      //     } else {
      //       if (this.totalExtraCharge > 0) {
      //         this.totalTax = Math.round(((sumTax + (this.$store.state.selected_outlet.service_charge_non_taxable ? 0 : this.totalExtraCharge)) * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //       } else {
      //         // this.totalTax = Math.round((sumTax * Number(this.selected_outlet.tax_rate)) * 100) / 100
      //         this.totalTax = Number(this.selected_outlet.tax_rate) > 0 ? Math.round(sumTax - (sumTax / (1 + Number(this.selected_outlet.tax_rate)))) : 0
      //       }
      //     }
      //   }
      // }

      // if (this.$store.state.selected_type === 'OL-TAKE-AWAY' || this.$store.state.selected_type === 'DELIVERY') {
      //   this.totalPrice = this.totalPrice + this.extra_charge
      // } else {
      //   this.totalExtraCharge = Math.round((this.totalPrice * this.extra_charge) * 100) / 100
      //   this.totalPrice = this.totalPrice + (this.totalPrice * this.extra_charge)
      // }

      if (Number(this.selected_outlet.tax_rate) !== 0 && !this.selected_outlet.price_tax_included) {
        this.totalPrice = this.totalPrice + this.totalTax
      }

      this.totalPriceWithoutShipping = this.totalPrice

      if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.dataInCart.shipping_delivery_type === 1) {
          if (this.totalPriceItem < Number(this.selected_outlet.delivery.minimum_order)) {
            this.totalPrice = this.totalPrice + (this.dataInCart.shipping_radius * this.$store.state.selected_outlet.delivery.cost_outside_radius)
          } else {
            if (this.dataInCart.shipping_radius > this.$store.state.selected_outlet.delivery.radius_free_delivery) {
              this.totalPrice = this.totalPrice + ((this.dataInCart.shipping_radius - this.$store.state.selected_outlet.delivery.radius_free_delivery) * this.$store.state.selected_outlet.delivery.cost_outside_radius)
            } else {
              this.totalPrice = this.totalPrice + 0
            }
          }
        } else if (this.dataInCart.shipping_delivery_type === 2) {
          this.totalPrice = this.totalPrice + Number(this.dataInCart.shipping_cost)
        }
      }

      if (this.$store.state.selected_type === 'RESERVATION' && !this.$isEmpty(this.$store.state.selected_outlet)) {
        if (this.$store.state.selected_outlet.reservation.reservation_payment_terms === 2) {
          if (this.$store.state.selected_outlet.reservation.reservation_payment_terms_amount_type === 0) {
            this.totalDownPaynent = Number(this.$store.state.selected_outlet.reservation.reservation_payment_terms_amount) + this.totalConvenienceFee
          } else {
            this.totalDownPaynent = ((this.totalPrice * Number(this.$store.state.selected_outlet.reservation.reservation_payment_terms_amount)) / 100) + this.totalConvenienceFee
          }
        } else if (this.$store.state.selected_outlet.reservation.reservation_payment_terms === 3) {
          this.totalDownPaynent = this.totalConvenienceFee
        }
      }
      this.CheckRound(this.totalPrice)
      // if (this.selected_outlet.url_id === 'bengongsteapantaiindahkapuk' || this.selected_outlet.url_id === 'bengongsteasshtaatdistrict8' || this.selected_outlet.url_id === 'setdemo1') {
      //   this.totalPrice = this.totalPrice + Number(3000)
      // }

      // if (this.$store.state.selected_type === 'OL-TAKE-AWAY' || this.$store.state.selected_type === 'DELIVERY') {
      //   if (Number(this.selected_outlet.tax_rate) !== 0) {
      //     if (this.dataInCart.shipping_radius > this.selected_outlet.delivery.radius_free_delivery) {
      //       this.totalPrice = sum + payment_charge + this.totalTax + ((this.dataInCart.shipping_radius - this.selected_outlet.delivery.radius_free_delivery) * this.selected_outlet.delivery.cost_outside_radius)
      //     } else {
      //       this.totalPrice = sum + payment_charge + this.totalTax
      //     }
      //   } else {
      //     if (this.dataInCart.shipping_radius > this.selected_outlet.delivery.radius_free_delivery) {
      //       this.totalPrice = sum + payment_charge + ((this.dataInCart.shipping_radius - this.selected_outlet.delivery.radius_free_delivery) * this.selected_outlet.delivery.cost_outside_radius)
      //     } else {
      //       this.totalPrice = sum + payment_charge
      //     }
      //   }
      // }
    },
    async CheckRound(amount) {
      try {
        const data_payload = {
          total_amount: amount,
          remark: this.$store.state.selected_type
        }
        const data = await checkRounding(data_payload)
        this.$store.state.loading_axios = false
        this.data_rounding = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async createOrder() {
      this.dataInCart.total_amount = !this.$isEmpty(this.data_rounding) && this.data_rounding.is_rounded ? this.data_rounding.data.total_amount : this.totalPrice
      this.dataInCart.total_amount_without_shipping = this.totalPriceWithoutShipping
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$store.dispatch('saveDataCartReservation', this.dataInCart)
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$store.dispatch('saveDataCartTakeAway', this.dataInCart)
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.$store.dispatch('saveDataCartDelivery', this.dataInCart)
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$store.dispatch('saveDataCartDineIn', this.dataInCart)
      }
      if (this.checkUser.auth_by === 'SYSTEM' && this.$store.state.selected_type !== 'DINE-IN') {
        const tmii_outlet = this.$store.state.store_tmii
        const url_id = this.$store.state.url_domain
        if (tmii_outlet.indexOf(url_id) !== -1) {
          this.$router.push({ name: 'login_guest', query: { redirect: 'payment' }}).catch(() => {})
        } else {
          this.$router.push({ name: 'login', query: { redirect: 'payment' }}).catch(() => {})
        }
      } else {
        this.$router.push({ name: 'payment' }).catch(() => {})
      }
    },
    openSelectLocation() {
      this.$router.push({ name: 'search_map' }).catch(() => {})
    },
    searchVoucher: debounce(async function(val) {
      if (val === null) {
        val = ''
      }
      this.search_text = val
      this.discounts = []
      if (val !== '') {
        this.settingScroll = true
        this.params.page = 1
        this.params.per_page = 20
        this.searching = true
        await this.loadDataSearch()
      } else {
        this.settingScroll = true
        this.params.page = 1
        this.params.per_page = 20
        this.searching = false
        await this.loadDiscount()
      }
    }, 1000),
    async clearSearchData() {
      await this.searchVoucher()
    },
    async loadDataSearch() {
      if (this.searching === true && this.search_text !== null) {
        try {
          let remark = ''
          if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
            remark = 'use_take_away'
          } else if (this.$store.state.selected_type === 'DELIVERY') {
            remark = 'use_delivery'
          } else if (this.$store.state.selected_type === 'DINE-IN') {
            remark = 'use_dine_in'
          } else if (this.$store.state.selected_type === 'RESERVATION') {
            remark = 'use_reservation'
          }
          const params = {
            page: this.params.page++,
            per_page: this.params.per_page,
            search_text: [this.search_text, 1],
            search_operator: ['like', '='],
            search_column: ['title', remark]
          }
          const { data } = await getDataDiscount(params)
          this.settingScroll = (data.data.length < this.params.per_page)
          this.$store.state.loading_axios = false
          for (var i in data.data) {
            this.discounts.push(data.data[i])
          }
        } catch (e) {
          this.discounts = []
          if (e.statusCode === 401) {
            this.$store.dispatch('fetchToken')
            const tmii_outlet = this.$store.state.store_tmii
            const url_id = this.$store.state.url_domain
            if (tmii_outlet.indexOf(url_id) !== -1) {
              this.$router.push({ name: 'login_guest', query: { redirect: this.$route.name }}).catch(() => {})
            } else {
              this.$router.push({ name: 'login', query: { redirect: this.$route.name }}).catch(() => {})
            }
          } else {
            this.$store.state.show_error = true
            this.$store.state.error_message = e.string
            this.$store.state.error_type = e.statusCode
          }
        }
      }
    },
    async selectVoucher(idx, item) {
      this.discData = {}
      this.sheetDetail = true
      this.disabledHit = true
      this.voucher = {}
      try {
        const { data } = await getDataDetailDiscount(item.id)
        this.$store.state.loading_axios = false
        this.voucher = data.data
        this.voucher.discount_amount = Number(this.voucher.discount_amount)
        this.discData = item
        this.disabledHit = false
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    closeShowDetail() {
      this.sheetDetail = false
    },
    checkStockMaterials(obj) {
      let is_available = true
      const _selected_type = this.$store.state.selected_type
      const _storage = '_data_cart_' + _selected_type
      if (obj.materials.length > 0) {
        for (let m = 0; m < obj.materials.length; m++) {
          if (obj.materials[m].product_out_stock) {
            is_available = false
            break
          } else {
            if (obj.materials[m].material_product_variant_id) {
              if (Number(obj.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(obj.materials[m].material_product_variant_id, _storage, 'variant') + (1 * Number(obj.materials[m].qty)) > (Number(obj.materials[m].product_stock_qty) - Number(obj.materials[m].product_hold_qty))) {
                    is_available = false
                    break
                  }
                }
              }
            } else {
              if (Number(obj.materials[m].track_inventory) === 1) {
                if (this.$store.state.selected_outlet.pos_disallow_sell_no_stock) {
                  if (this.$stockCart(obj.materials[m].material_product_id, _storage) + (1 * Number(obj.materials[m].qty)) > (Number(obj.materials[m].product_stock_qty) - Number(obj.materials[m].product_hold_qty))) {
                    is_available = false
                    break
                  }
                }
              }
            }
          }
        }
      }
      return is_available
    }
  }
}
</script>
